import React from 'react';
import type { PollCampaignProps, PollOptionProps, PollProps, PollResponseProps } from "../../types"
import { Icons } from "../../Components"
import { useColors } from '../../constants/useColors';
import { Button, Text, View } from '../../Components/Themed';

type PollSelectCardProps = {
    selected?:boolean,
    poll_campaign:PollCampaignProps,
    poll:PollProps,
    disabled?:boolean,
    show_response?:boolean,
    response_option?:PollOptionProps,
    poll_response?:PollResponseProps,
    onSelect:(poll:PollProps) => void
}

const PollSelectCard = ({ poll, disabled, poll_campaign, poll_response, show_response, response_option, onSelect }:PollSelectCardProps) => {
    const Colors = useColors();
    const getResultColor = () => {
        switch(poll_response?.result_ind){
            case 'win': return Colors.text.success
            case 'lose': return Colors.text.error
            case 'draw': return Colors.text.warning
            default: return Colors.text.h1
        }
    }

    const getStatusColor = () => {
        switch(poll.status) {
            case 'closed': return Colors.absolutes.highlights.highlight300Faded
            case 'active': return Colors.absolutes.highlights.highlight400Faded
            default: return Colors.absolutes.highlights.highlight500Faded
        }
    }


    const getResultIcon = () => {
        let color = getResultColor()
        switch(poll_response?.result_ind){
            case 'win':
                return <Icons.CheckIcon color={color} size={16} />
            case 'lose':
                return <Icons.CloseIcon color={color} size={12} />
            default: 
                if(poll.status == 'closed'){
                    return <Icons.CloseIcon color={color} size={10} />
                }
                console.log('DOWN HERE!!!')
                return <></>
        }
    }

    const getStatusIcon = () => {
        //let color = getResultColor()
        switch(poll.status){
            case 'closed':
                return <Icons.LockClosedIcon color={Colors.text.h1} size={14} />
            case 'active':
                return <Icons.InProgressIcon color={Colors.text.h1} size={14} />
            default:
                return <Icons.PausedIcon color={Colors.text.h1} size={14} />
        }
    }

    return (
        <Button transparent disabled={disabled} style={{ padding:10, borderRadius:22, flexDirection:'row' }} onPress={() => onSelect(poll)}>
            <View transparent style={{ height:20, width:20, borderRadius:100, marginRight:10, justifyContent:'center' }}>
                <Text size={12} color={Colors.text.h1} weight='bold' textAlign='center'>{poll.priority}</Text>
            </View>
            <View transparent style={{ flex:1 }}>
                {poll_campaign.campaign_type == 'trivia' && !poll_response && poll.status != 'closed' ? 
                <Text size={14} color={Colors.text.h1} weight='bold'>{poll.hidden_clue?`Hint: ${poll.hidden_clue}`:`Question Hidden`}</Text>
                :
                <Text size={14} color={Colors.text.h1} weight='bold'>{poll.poll_question}</Text>
                }
                {poll.status == 'closed' || show_response ?
                <View transparent style={{ marginTop:10, flexDirection:'row' }}>
                    {response_option && poll.poll_type == 'select' ?
                    <Text style={{ flex:1 }} size={12} color={Colors.text.h1}>My Answer: <Text size={12} color={Colors.text.h1} theme='h2'>{response_option.option_name}</Text></Text>
                    : response_option && poll.poll_type == 'input' ?
                    <Text style={{ flex:1 }} size={12} color={Colors.text.h1}>My Answer: <Text size={12} color={Colors.text.h1} theme='h2'>{poll_response?.input_value}</Text></Text>
                    :poll.status == 'closed' || poll_response?.timed_out ?
                    <Text style={{ flex:1 }} size={12} color={Colors.text.h1} weight='light'>TIMED OUT</Text>
                    :<></>}
                    <View style={{ marginLeft:5 }}>
                        {getResultIcon()}
                    </View>
                </View>
                :
                <View transparent style={{flexDirection:'row', alignItems:'center'}}>
                    <Text style={{ flex:1 }} size={12} color={Colors.text.h1} weight='light'>{poll.poll_type == 'select' ? 'Multiple Choice': 'Type Answer'}</Text>
                    <View transparent style={{ flexDirection:'row', alignItems:'center', padding:10, backgroundColor:getStatusColor(), borderRadius:22 }}>
                        {getStatusIcon()}
                        {poll.seconds_allowed && poll.status != 'closed' ? 
                        <Text style={{ marginLeft:5 }} size={12} color={Colors.text.h1} weight='bold'>{poll.seconds_allowed} Sec</Text>
                        :<></>}
                    </View>
                </View>
                }
            </View>
        </Button>
    )
}

export default PollSelectCard